/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Allfields2Inputs */

const id_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua bidang`)
};

const ms_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua medan`)
};

const da_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle felter`)
};

const de_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Felder`)
};

const en_us2_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All fields`)
};

const es_es2_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los campos`)
};

const es_mx2_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los campos`)
};

const fil_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng field`)
};

const fr_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les champs`)
};

const it_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i campi`)
};

const hu_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden mező`)
};

const nl_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle velden`)
};

const no_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle felt`)
};

const pl_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie pola`)
};

const pt_br2_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os campos`)
};

const pt_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os campos`)
};

const ro_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate câmpurile`)
};

const fi_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki kentät`)
};

const sv_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla fält`)
};

const vi_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả trường`)
};

const tr_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm alanlar`)
};

const cs_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechna pole`)
};

const bg_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички полета`)
};

const ru_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все поля`)
};

const uk_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі поля`)
};

const ar_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع الحقول`)
};

const hi_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी फ़ील्ड`)
};

const th_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกฟิลด์`)
};

const ja_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのフィールド`)
};

const zh_cn2_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有字段`)
};

const zh_hant1_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有欄位`)
};

const ko_offerdetail_changelog_allfields2 = /** @type {(inputs: Offerdetail_Changelog_Allfields2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 필드`)
};

/**
* | output |
* | --- |
* | "All fields" |
*
* @param {Offerdetail_Changelog_Allfields2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_allfields2 = /** @type {((inputs?: Offerdetail_Changelog_Allfields2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Allfields2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_allfields2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_allfields2(inputs)
	if (locale === "da") return da_offerdetail_changelog_allfields2(inputs)
	if (locale === "de") return de_offerdetail_changelog_allfields2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_allfields2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_allfields2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_allfields2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_allfields2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_allfields2(inputs)
	if (locale === "it") return it_offerdetail_changelog_allfields2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_allfields2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_allfields2(inputs)
	if (locale === "no") return no_offerdetail_changelog_allfields2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_allfields2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_allfields2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_allfields2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_allfields2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_allfields2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_allfields2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_allfields2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_allfields2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_allfields2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_allfields2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_allfields2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_allfields2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_allfields2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_allfields2(inputs)
	if (locale === "th") return th_offerdetail_changelog_allfields2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_allfields2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_allfields2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_allfields2(inputs)
	return ko_offerdetail_changelog_allfields2(inputs)
});
export { offerdetail_changelog_allfields2 as "offerDetail.changelog.allFields" }